import { preventDoubleClick } from '../global/_doubleClick';
import { customCheckBox } from '../global/_customCheckBox';
import { stripRestrictedCharFromInput } from '../global/_stripRestrictedCharFromInput';
import { inlineFormValidationOnBlur } from '../global/_inlineFormValidationOnBlur';
import { startIntl } from '../international/_intl';
import { formValidation } from '../global/_formValidation';

export var ajaxShareProduct = function (params, returnHTML) {
	function myCallback() {
		formValidation();
		preventDoubleClick();
		customCheckBox();
		stripRestrictedCharFromInput();
		inlineFormValidationOnBlur();
		startIntl();
	}
	if (params.formName) {
		var form = $('#' + params.formName),
			emailTo = '';
		$.each(form.find(':input[name^="recipientEmails"]'), function () {
			if ($(this).val().length > 0) {
				emailTo = emailTo + ',' + $(this).val();
			}
			$(this).remove();
		});
		form.append('<input type="hidden" name="recipientEmails" value="' + emailTo.substr(1) + '" />');
		$.ajax({
			url: '/webapp/wcs/stores/servlet/ProductEmail',
			cache: false,
			type: 'POST',
			data: form.serialize(),
			success: function (html) {
				$('.modal-body').addClass('modal-scroll');
				if (typeof returnHTML == 'function') returnHTML(html, myCallback);
				else {
					$('.modal-body').html(html);
					myCallback();
				}
				return false;
			},
		});
	}
	startIntl();
};
